export class UpdatePublishRequest {
    resourceId: number;
    attributeString: string;
    sellerIds: number[];
}
